import React from 'react'

import useStyles from './action-confirmation-modal.style'

import { useSelector } from 'react-redux'
import { selectConfirmationModal } from '@selectors'

import { Button, IconInline, Paragraph, Title, WHITE } from '@omnilert/components'

import Modal from '@components/modal/modal.component'
import i18n from 'i18n-js'
import { BUTTON_CANCEL } from '../../assets/i18n/strings'

const ActionConfirmationModal = (props) => {
  const confirmationModal = useSelector(selectConfirmationModal)

  const bodyText = confirmationModal?.bodyText
  const confirmButtonBackgroundColor = confirmationModal?.confirmButtonBackgroundColor
  const confirmButtonHoverBackgroundColor = confirmationModal?.confirmButtonHoverBackgroundColor
  const confirmText = confirmationModal?.confirmText || 'OK'
  const iconName = confirmationModal?.iconName
  const iconVariant = confirmationModal?.iconVariant
  const isCancellable = confirmationModal?.isCancellable
  const isVisible = confirmationModal?.isVisible
  const onConfirm = confirmationModal?.onConfirm
  const onDismiss = confirmationModal?.onDismiss
  const title = confirmationModal?.title

  const handleOnClick = () => {
    onConfirm()
  }

  const handleOnClose = () => {
    onDismiss()
  }

  const classes = useStyles({ iconVariant, ...props })

  return (
    <Modal isVisible={isVisible}>
      <div className={classes.iconContainer}>
        <IconInline
          className={classes.icon}
          name={iconName}
          rotate={0}
          size={162}
        />
      </div>
      <div className={classes.modalTextContainer}>
        <Title
          color={WHITE}
          size='md'
        >
          {title}
        </Title>
        <div>
          {bodyText && bodyText.map(({ text, color, size }, index) => (
            <Paragraph
              key={`bodyText-${index}`}
              className={classes.bodyText}
              color={color}
              size={size}
            >
              {text}
            </Paragraph>
          ))}
        </div>
      </div>
      <Button
        backgroundColor={confirmButtonBackgroundColor}
        className={classes.button}
        fullWidth
        hoverBackgroundColor={confirmButtonHoverBackgroundColor}
        onClick={handleOnClick}
        title={confirmText}
        variant='solid'
      />
      {isCancellable && <Button
        className={classes.button}
        color={WHITE}
        fullWidth
        onClick={handleOnClose}
        title={i18n.t(BUTTON_CANCEL)}
      />}
    </Modal>
  )
}

export default ActionConfirmationModal
